import React, { useState, useEffect } from 'react';

const OutOfPovsScreen = ({ onNavigateBack, onInviteFriends }) => {
    const [showTimer, setShowTimer] = useState(false);
    const [showInvite, setShowInvite] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds

    useEffect(() => {
        // Show timer after 2 seconds
        const timerTimeout = setTimeout(() => {
            setShowTimer(true);
        }, 2000);

        // Show invite button after 4 seconds
        const inviteTimeout = setTimeout(() => {
            setShowInvite(true);
        }, 4000);

        return () => {
            clearTimeout(timerTimeout);
            clearTimeout(inviteTimeout);
        };
    }, []);

    useEffect(() => {
        if (!showTimer) return;

        const interval = setInterval(() => {
            setTimeLeft(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [showTimer]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    const getProgressPercentage = () => {
        return ((300 - timeLeft) / 300) * 100;
    };

    return (
        <div className="out-of-povs-screen">
            <div className="header">
                <button className="back-btn" onClick={onNavigateBack}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
            <div className="out-of-povs-content">
                <div className="out-of-povs-text">
                    You're out of POVs.<br/>
                    You can send POVs again<br/>
                    in a few minutes – go hydrate,<br/>
                    stretch, or stare dramatically<br/>
                    out a window until then.
                </div>
                <div className="spacer"></div>
                {showTimer && (
                    <div className="countdown-timer">
                        <div className="timer-display">
                            <span className="timer-text">{formatTime(timeLeft)}</span>
                        </div>
                        <div className="timer-bar">
                            <div 
                                className="timer-progress"
                                style={{ width: `${getProgressPercentage()}%` }}
                            ></div>
                        </div>
                    </div>
                )}
                {showInvite && (
                    <button className="invite-btn" onClick={onInviteFriends}>
                        Invite Friends
                    </button>
                )}
            </div>
        </div>
    );
};

export default OutOfPovsScreen;